__turbopack_context__.v({
  "className": "Z04g8a_className",
  "variable": "Z04g8a_variable",
});
